import React from "react";
import {attributesToProps, domToReact} from 'html-react-parser'

const OpenHotspot = ({node, options, onClick}) => {
  const props = attributesToProps(node.attribs);

  const handleOnClick = () => {
    onClick()
  }

  if (!onClick) {
    return <div className={"alert alert-danager"}>
      Invalid context (missing hotspot click handler).
    </div>
  }

  return <div {...props} onClick={handleOnClick}>
    {domToReact(node.children, options)}
  </div>;
}

export default OpenHotspot
